import { useEffect, useState } from "react";
import ToggleButton from '@mui/material/ToggleButton';

const previewCount = 9;

const GroupGeneButtonItems = ({ layer, layerVisibility, layerExpanded, map, styles }) => {

  const [geneItems, setGeneItems] = useState(layer?.title);
  const [buttonToggleState, setButtonToggleState] = useState(geneItems.reduce((obj, key) => { obj[key] = true; return obj }, {}));
  const [showFullGeneList, setShowFullGeneList] = useState(false);

  useEffect(() => {
    setGeneItems(layer?.title);
  }, [layer]);

  useEffect(() => {
    if (layerVisibility) {
      layer?.subLayerIds.map((layerId, idx) => {
        map?.current?.setLayoutProperty(layerId, 'visibility', buttonToggleState[geneItems[idx]] ? 'visible' : 'none');
      });
    } else {
      layer?.subLayerIds.map((layerId) =>  map?.current?.setLayoutProperty(layerId, 'visibility', 'none'));
    }
  }, [layerVisibility]);

  useEffect(() => {
    if (geneItems && Array.isArray(geneItems) && styles?.subLayers) {
      const newButtonToggleState = styles.subLayers.reduce((acc, { gene, visibility }) => {
        acc[gene] = visibility;
        return acc;
      }, {});
      if (Object.keys(buttonToggleState).toString() === Object.keys(newButtonToggleState).toString()) {
        layer?.subLayerIds.map((layerId, idx) => {
          map?.current?.setLayoutProperty(layerId, 'visibility', newButtonToggleState[geneItems[idx]] ? 'visible' : 'none');
        });
        setButtonToggleState(newButtonToggleState);
      }
    }
  }, [styles]);

  useEffect(() => {
    !layerExpanded && setShowFullGeneList(false);
  }, [layerExpanded]);

  const handleOnClickGeneGroupItem = (event, clickedGene) => {

    layer?.subLayerIds.map((layerId, idx) => {
      geneItems[idx] === clickedGene && map?.current?.setLayoutProperty(layerId, 'visibility', !buttonToggleState[geneItems[idx]] ? 'visible' : 'none');
    });
    if (buttonToggleState.hasOwnProperty(clickedGene)) {
      setButtonToggleState(prevState => ({
        ...prevState,
        [clickedGene]: !buttonToggleState[clickedGene]
      }));
    }
  }

  const handleOnClickShowFullItems = () => {
    setShowFullGeneList(true);
  }

  return (
    <>
      {
        geneItems.length > previewCount && !showFullGeneList ?
          <PreviewGeneList
            geneItems={geneItems}
            buttonToggleState={buttonToggleState}
            handleOnClickGeneGroupItem={handleOnClickGeneGroupItem}
            handleOnClickShowFullItems={handleOnClickShowFullItems}
            layerVisibility={layerVisibility}
          /> : <FullGeneList
            geneItems={geneItems}
            buttonToggleState={buttonToggleState}
            handleOnClickGeneGroupItem={handleOnClickGeneGroupItem}
            layerVisibility={layerVisibility}
          />
      }
    </>
  )
}

const PreviewGeneList = ({ geneItems, buttonToggleState, handleOnClickGeneGroupItem, handleOnClickShowFullItems, layerVisibility }) => {
  return (
    <>
      {geneItems.slice(0, previewCount)?.map((gene) => (
        <ToggleButton
          className='layer-group-toggle-button'
          size='small'
          key={gene}
          selected={buttonToggleState[gene]}
          disabled={!layerVisibility}
          value={gene}
          onClick={handleOnClickGeneGroupItem}
        >
          {buttonToggleState[gene] ? gene : <s>{`${gene}`}</s>}
        </ToggleButton>
      ))}
      <ToggleButton
        className='layer-group-toggle-button'
        size='small'
        key='show-full-gene-items-button'
        selected={true}
        onClick={handleOnClickShowFullItems}
        value='full-list'
      >
        ...
      </ToggleButton>
    </>
  )
}

const FullGeneList = ({ geneItems, buttonToggleState, handleOnClickGeneGroupItem, layerVisibility }) => {

  return (
    <>
      {geneItems?.map((gene) => (
        <ToggleButton
          className='layer-group-toggle-button'
          size='small'
          key={gene}
          selected={buttonToggleState[gene]}
          disabled={!layerVisibility}
          value={gene}
          onClick={handleOnClickGeneGroupItem}
        >
          {buttonToggleState[gene] ? gene : <s>{`${gene}`}</s>}
        </ToggleButton>
      ))}
    </>
  )
}

export default GroupGeneButtonItems;